var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dashboard-analytics"}},[_c('div',{staticClass:"vx-row mt-6"},[_c('div',{staticClass:"vx-col w-full"},[_c('dashboard-grid')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }